// Item 216 batch 1 — read-only IdP-preset catalog client. Backs the
// SetupWizard's SSO step: lists the item-185 SAML presets
// (auth.PresetClaimMapping) so the operator can see what
// ORBITALREG_SAML_IDP_PRESET does for their IdP before setting it.

import useSWR from 'swr';
import { parseErrorResponse } from './problem';

export interface SAMLClaimMapping {
  email: string;
  display_name: string;
  groups: string;
  role?: string;
  object_id?: string;
  tenant_id?: string;
}

export interface SAMLPreset {
  id: string;
  label: string;
  blurb: string;
  claim_mapping: SAMLClaimMapping;
  env_var: string;
}

const fetcher = async (url: string) => {
  const r = await fetch(url, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!r.ok) throw await parseErrorResponse(r);
  return r.json();
};

export function useSAMLPresets() {
  return useSWR<SAMLPreset[]>('/api/admin/saml/presets', fetcher);
}
